import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Link } from 'react-router-dom';
import Button from '../../components/button/Button';
import Logo from '../../components/logo/Logo';
import query from '../../query';
import {Container} from 'reactstrap';
import AuthContext from '../../context/authContext';
import { clearStoredMfaMetadata } from './MfaUtils';

export default function MultifactorAuthenticationNotice() {
  const history = useHistory();
  const [setError] = useState(null);

  const [activateMfaValidation, { loading }] = useMutation(query.activateMfaValidation, {
    errorPolicy: 'all',
  });

  const userId = parseInt(localStorage.getItem('user_auth_id'), 10);
  const scheduledActivationDateMfa = localStorage.getItem('scheduled_activation_date_mfa');

  const handleActivate = async (activateNow) => {
    try {
      const { data } = await activateMfaValidation({
        variables: {
          userId,
          activateNow
        }
      });
      
      if (activateNow) {
        if (data?.activateMfaValidation?.success) {
          history.push('/showMultifactorAuthentication');
        } else if (data?.activateMfaValidation?.errorMessage) {
          setError(data.activateMfaValidation.errorMessage);
        }
      } else if (!activateNow) {
        clearStoredMfaMetadata();
        localStorage.setItem('activateMfaLater', true);
        history.push('/AccountSummary');
      } else {
        setError('It was not possible to activate MFA. Try again.');
      }
    } catch (error) {
      console.error('[handleActivate] Error activating MFA:', error);
    }
  };

  const { logout } = useContext(AuthContext);
  const logOut = (e) => {
    e.preventDefault();
    localStorage.removeItem('loan_id');
    localStorage.removeItem('user_auth_data');
    clearStoredMfaMetadata();
    logout();
    history.push('/');
  };

  return (
    <div>
      <Container>
        <div className="py-1 py-lg-5 align-element-center">
          <div className="col-lg-6 col-12 col-md-7 m-auto text-center">
            <Logo />
            <h2 className="mb-3 mt-3">
              <b>Security Notice</b>
            </h2>
            <p className="mb-2">
              As of{' '}
              <span className="text-danger font-weight-bold">
                {scheduledActivationDateMfa}
              </span>
              , Multi-Factor Authentication (MFA) will be mandatory.
            </p>
            <p className="mb-4">
              Please proceed to activate it immediately to ensure continuous secure access.
            </p>
  
            <div className="d-flex justify-content-center gap-2">
              <Button
                title={loading ? 'Loading...' : 'Activate Now'}
                onClick={() => handleActivate(true)}
                className="btn alert-button text-white shadow-0"
              />
              <Button
                title={loading ? 'Loading...' : 'Activate Later'}
                onClick={() => handleActivate(false)}
                className="btn btn-outline-secondary shadow-0"
              />
            </div>
  
            <div className="row justify-content-center mt-4">
              <div className="col-6 text-center">
                <Link to="/" onClick={logOut} className="text-muted">
                  <i>
                    <u>Return to Homepage</u>
                  </i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
